import React from "react";
import "../styles/Consumerbanner.css";
import intake1 from "./assets/stamina/intake1.png";
import intake2 from "./assets/stamina/intake2.png";

const StaminaConsumeSection = () => {
  const steps = [
    {
      title: "Step 1",
      text: "Take 1-2 tablets or capsules of STAMINA supplement",
      image: intake1,
    },
    {
      title: "Step 2",
      text: "Consume with warm milk or water, preferably after breakfast. Take daily for best results and improved bone health",
      image: intake2,
    },
  ];

  return (
    <section className="consume-banner">
      <h2 className="consume-heading">
        सेवन करने का तरीका (How To Consume)
      </h2>

      <div className="consume-images">
        {steps.map((step, index) => (
          <div className="consume-card" key={index}>
            <img 
              src={step.image}
              alt={step.title}
              style={{
                width: '100%',
                height: 'auto',
                borderRadius: '10px',
                objectFit: 'contain',
                marginBottom: '15px'
              }}
            />
            <h4>{step.title}</h4>
            <p>{step.text}</p>
          </div>
        ))}
      </div>
    </section>
  );
};

export default StaminaConsumeSection;
